import { FC } from 'react';

import { Dialog, DialogContent } from '../ui/dialog';
import { NbButton } from '@/components/Neobrut';

interface ConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  description?: string;
}

export const ConfirmationDialog: FC<ConfirmationDialogProps> = ({
  open,
  onClose,
  onConfirm,
  title,
  description,
}) => {
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent
        className="w-full max-w-[92%] p-0 sm:max-w-[80%] md:max-w-[60%] lg:max-w-md"
        style={{
          background: 'var(--nb-paper)',
          border: '3px solid var(--nb-ink)',
          boxShadow: '6px 6px 0 var(--nb-ink)',
          borderRadius: 'var(--nb-radius)',
        }}
      >
        <div className="px-5 pb-2 pt-5">
          <div
            className="text-[10px] font-bold uppercase tracking-[0.08em] opacity-60"
            style={{ fontFamily: '"JetBrains Mono", monospace' }}
          >
            / confirmación
          </div>
          <h2 className="font-display mt-1 text-[22px] leading-tight">
            {title ?? '¿Estás seguro?'}
          </h2>
          <p className="mt-2 text-[13px] font-medium opacity-80">
            {description ?? 'Esta acción no se puede deshacer.'}
          </p>
        </div>
        <div
          className="grid grid-cols-2 gap-2 px-5 pb-5"
          style={{ borderTop: 'none' }}
        >
          <NbButton fill="paper" onClick={onClose}>
            Cancelar
          </NbButton>
          <NbButton fill="urgent" onClick={onConfirm}>
            Confirmar
          </NbButton>
        </div>
      </DialogContent>
    </Dialog>
  );
};
